import { createRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { Splash } from '@forto-dev/phoenix-ui-core/ship'

import { createAppErrorFallback } from '@/fragments/create-error-fallback.tsx'
import { rootRoute } from '@/routes/root'

const signupInvitedRouteSchema = z.object({
  type: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  customer: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  user: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  digest: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
})

export const signupInvitedRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/signup',
  validateSearch: signupInvitedRouteSchema,
  errorComponent: createAppErrorFallback(),
  pendingComponent: Splash,
}).lazy(() => import('./signupInvited').then((d) => d.Route))

export type SignupInvitedRouteSearchParams = z.infer<typeof signupInvitedRouteSchema>
